export default __webpack_public_path__ + "54c669a43f5bd7e20507fffd5e542804.svg";